import * as React from 'react';
import { colors } from '../styles/colors';

interface IProps {
    containerStyle: React.CSSProperties;
    currentStep: number;
    maxSteps: number;
}
export class ActivityIndicator extends React.Component<IProps> {
    private renderIcon(isSelected: boolean, key: number) {
        const color = isSelected ? colors.DARK_GREEN : colors.IDLE_INDICATOR;
        return <div style={styles.icon(color)} key={key} />;
    }

    public render() {
        return (
            <div style={{ ...this.props.containerStyle, ...styles.container }}>
                {Array(this.props.maxSteps + 1)
                    .fill(true)
                    .map((e, i) => {
                        return this.renderIcon(i === this.props.currentStep, i);
                    })}
            </div>
        );
    }
}

const styles = {
    icon: (color: string) => {
        return {
            height: 10,
            width: 10,
            borderRadius: 15,
            backgroundColor: color
        };
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/ActivityIndicator.tsx